module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","privacyPolicy":"Datenschutzerklärung"},"en":{"back":"Back","privacyPolicy":"Privacy policy"}}')
  delete Component.options._Ctor
}
